import React, { useEffect, useState } from "react";

import { GetDeliveryBucketListResponse } from "../../../common/api/delivery-api/GetDeliveryBucketListResponse";
import { useDeliveryBucketsApi } from "../api/useDeliveryBucketsApi";
import { DeliveryBucketItem, mapToDeliveryBucketItem } from "../listing/DeliveryBucketItem";
import { DeliveryBucketListingContext } from "./DeliveryBucketListingContext";

interface DeliveryBucketListingProviderProps {
    children: React.ReactNode;
}

export const DeliveryBucketListingProvider: React.FC<DeliveryBucketListingProviderProps> = (
    props: DeliveryBucketListingProviderProps
) => {
    const { children } = props;
    const { getDeliveryBucketList } = useDeliveryBucketsApi();

    const [deliveryBucketItems, setDeliveryBucketItems] = useState<DeliveryBucketItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getDeliveryBucketList().then((response: GetDeliveryBucketListResponse) => {
            const deliveryBuckets = response?.items?.map(mapToDeliveryBucketItem);

            setDeliveryBucketItems(deliveryBuckets);
            setIsLoading(false);
        });
    }, []);

    const addDeliveryBucketItem = (item: DeliveryBucketItem) => {
        setDeliveryBucketItems((prevState) => [...prevState, item]);
    };

    const deleteDeliveryBucketItem = (deliveryBucketId: string) => {
        setDeliveryBucketItems((prevState) =>
            prevState.filter(
                (deliveryBucketItem: DeliveryBucketItem) => deliveryBucketItem.deliveryBucketId !== deliveryBucketId
            )
        );
    };

    const disableDeliveryBucketItem = (deliveryBucketId: string) => {
        setDeliveryBucketItems((prevState) =>
            prevState.map((deliveryBucketItem: DeliveryBucketItem) =>
                deliveryBucketItem.deliveryBucketId === deliveryBucketId
                    ? {
                          ...deliveryBucketItem,
                          isActive: false,
                          isModified: true
                      }
                    : deliveryBucketItem
            )
        );
    };

    const enableDeliveryBucketItem = (deliveryBucketId: string) => {
        setDeliveryBucketItems((prevState) =>
            prevState.map((deliveryBucketItem: DeliveryBucketItem) =>
                deliveryBucketItem.deliveryBucketId === deliveryBucketId
                    ? {
                          ...deliveryBucketItem,
                          isActive: true,
                          isModified: true
                      }
                    : deliveryBucketItem
            )
        );
    };

    return (
        <DeliveryBucketListingContext.Provider
            value={{
                deliveryBucketItems,
                isLoading,
                addDeliveryBucketItem,
                deleteDeliveryBucketItem,
                disableDeliveryBucketItem,
                enableDeliveryBucketItem
            }}
        >
            {children}
        </DeliveryBucketListingContext.Provider>
    );
};
